(() => {
  const root=document.querySelector('[data-bma-shell]');
  if(!root || root.dataset.ready)return;
  root.dataset.ready='true';
  const media=matchMedia('(max-width:749px)');
  const dialog=root.querySelector('[data-bma-dialog]');
  const status=root.querySelector('[data-bma-status]');
  const items=root.querySelector('[data-bma-items]');
  const total=root.querySelector('[data-bma-total]');
  const money=new Intl.NumberFormat('pt-PT',{style:'currency',currency:'EUR'});
  const fullCart=root.querySelector('[data-bma-full-cart]');
  let opener,reading=0,adding=false,toastTimer;
  const isCart=()=>location.pathname.replace(/\/$/,'')===new URL(root.dataset.cartUrl,location.origin).pathname.replace(/\/$/,'');
  const sameOriginPath=(value)=>{const url=new URL(value,location.origin);return url.origin===location.origin?url.pathname:null;};
  function previewLink(value){
    const url=new URL(value,location.origin);
    if(root.dataset.preview&&url.origin===location.origin)url.searchParams.set('preview_theme_id',root.dataset.preview);
    return url.href;
  }
  root.querySelectorAll('a[href]').forEach(a=>a.href=previewLink(a.href));
  const current=location.pathname.replace(/\/$/,'')||'/';
  const homePath=new URL(root.dataset.rootUrl,location.origin).pathname.replace(/\/$/,'')||'/';
  const active=current===homePath?root.querySelector('[data-bma-home]'):isCart()?root.querySelector('[data-bma-open]'):root.querySelector('[data-bma-collections]');
  active?.setAttribute('aria-current','page');
  const create=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;};
  function announce(message){const toast=root.querySelector('[data-bma-toast]');toast.textContent=message;toast.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.hidden=true,4500);}
  function countBadge(cart){
    root.querySelectorAll('[data-bma-count]').forEach(e=>{e.textContent=String(cart.item_count);e.hidden=cart.item_count===0;});
    const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if(bubble){bubble.hidden=!cart.item_count;const count=bubble.querySelector('[aria-hidden="true"]');if(count)count.textContent=String(cart.item_count);}
  }
  function render(cart){
    items.replaceChildren();countBadge(cart);
    total.textContent=money.format(cart.total_price/100);
    fullCart.hidden=!cart.items.length;
    if(!cart.items.length){
      const empty=create('div','bma-empty');empty.append(create('span','bma-empty-star','✦'),create('h3','','O próximo sorriso começa aqui.'),create('p','','Descubra a coleção e escolha um pequeno momento BONUM.'));
      const shop=create('a','bma-empty-link','Explorar as coleções');shop.href=previewLink(new URL('pages/escolher-bonum',new URL(root.dataset.rootUrl,location.origin)).href);empty.append(shop);items.append(empty);return;
    }
    for(const item of cart.items){
      const row=create('article','bma-line');
      if(item.image){const img=create('img','bma-line-image');img.src=item.image;img.alt=item.product_title;img.width=82;img.height=100;img.loading='lazy';row.append(img);}
      const info=create('div','bma-line-info');const name=create('a','bma-line-title',item.product_title);name.href=previewLink(item.url);info.append(name);
      if(item.variant_title&&item.variant_title!=='Default Title')info.append(create('p','bma-line-variant',item.variant_title));
      const properties=Object.entries(item.properties||{}).filter(([k,v])=>!k.startsWith('_')&&v!==null&&String(v).trim()!=='');
      if(properties.length){const details=create('details','bma-line-details');details.append(create('summary','','Sabores e detalhes'));const list=create('dl','');for(const [key,value]of properties){const pair=create('div','');pair.append(create('dt','',key),create('dd','',String(value)));list.append(pair);}details.append(list);info.append(details);}
      const price=create('div','bma-line-bottom');price.append(create('span','',String(item.quantity)+' × seleção'),create('strong','',money.format(item.final_line_price/100)));info.append(price);row.append(info);items.append(row);
    }
  }
  async function readCart(){
    const ticket=++reading;status.textContent='A preparar o seu carrinho…';
    const response=await fetch(root.dataset.cartJson,{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('cart');
    const cart=await response.json();if(ticket!==reading)return cart;
    render(cart);status.textContent=cart.items.length?'Tudo guardado. Reveja os detalhes antes de continuar.':'';return cart;
  }
  async function openCart(message){
    if(!media.matches){location.assign(fullCart.href);return;}
    opener=document.activeElement;
    if(typeof dialog.showModal!=='function'){location.assign(fullCart.href);return;}
    if(!dialog.open)dialog.showModal();
    document.documentElement.classList.add('bma-cart-open');
    try{await readCart();if(message)status.textContent=message;}catch{status.textContent='Não foi possível carregar o resumo. Abra o carrinho completo para confirmar.';fullCart.hidden=false;}
  }
  root.querySelectorAll('[data-bma-open]').forEach(b=>b.addEventListener('click',()=>openCart()));
  root.querySelectorAll('[data-bma-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
  dialog.addEventListener('close',()=>{document.documentElement.classList.remove('bma-cart-open');if(opener?.isConnected)opener.focus({preventScroll:true});});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  document.addEventListener('click',event=>{
    if(!media.matches||event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||isCart())return;
    const link=event.target.closest('header a[href]');if(!link)return;
    if(sameOriginPath(link.href)===sameOriginPath(root.dataset.cartUrl)){event.preventDefault();openCart();}
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!media.matches||event.defaultPrevented||!form.matches('form[action*="/cart/add"]')||!form.closest('.nx,.bonum-order,[data-bp-detail-dialog],[data-bp-root]'))return;
    if(!form.checkValidity())return;
    event.preventDefault();
    if(adding||form.dataset.bmaAdding==='true')return;
    adding=true;form.dataset.bmaAdding='true';form.setAttribute('aria-busy','true');
    const buttons=[...form.querySelectorAll('button[type="submit"],input[type="submit"]')];
    const disabled=buttons.map(b=>b.disabled);buttons.forEach(b=>b.disabled=true);
    document.documentElement.classList.add('bma-adding');
    let confirmed=false;
    try{
      const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!response.ok){let message='Não foi possível adicionar. Confirme a seleção e tente novamente.';try{const error=await response.json();if(typeof error.description==='string')message=error.description;}catch{}announce(message);return;}
      confirmed=true;
      document.dispatchEvent(new CustomEvent('cart:updated'));
      await openCart('Adicionado com carinho. Sabores, extras e dedicatória guardados.');
    }catch{
      announce(confirmed?'Produto adicionado. Abra o carrinho para confirmar os detalhes.':'Não foi possível confirmar a adição. Consulte o carrinho antes de tentar novamente.');
    }finally{
      buttons.forEach((b,i)=>b.disabled=disabled[i]);delete form.dataset.bmaAdding;form.removeAttribute('aria-busy');adding=false;document.documentElement.classList.remove('bma-adding');
    }
  });
  function keyboard(){
    const field=document.activeElement;
    const editing=field?.matches('textarea,input[type="text"],input[type="email"],input[type="tel"],input[type="search"],input[type="number"],input[type="password"],input[type="url"],input:not([type])');
    document.documentElement.classList.toggle('bma-keyboard',Boolean(editing&&media.matches));
  }
  window.visualViewport?.addEventListener('resize',keyboard);
  document.addEventListener('focusin',keyboard);document.addEventListener('focusout',()=>requestAnimationFrame(keyboard));
  const refresh=()=>{document.documentElement.classList.toggle('bma-mobile',media.matches);if(media.matches)readCart().catch(()=>{});else if(dialog.open)dialog.close();};
  media.addEventListener('change',refresh);refresh();
  window.addEventListener('pageshow',()=>{if(media.matches)readCart().catch(()=>{});});
  document.addEventListener('cart:updated',()=>{if(media.matches&&!dialog.open)readCart().catch(()=>{});});
})();
